module.exports = __webpack_public_path__ + "img/bg_intro_am.81b8b18.png";